module.exports = __webpack_public_path__ + "static/img/mail.eb3d45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/mail.png
// module id = TA2+
// module chunks = 1